import React, { useEffect, useState } from "react";

const API_BASE = process.env.REACT_APP_API_BASE || "http://localhost:8000";
const card = "rounded-xl border border-[#00ff90]/30 bg-[#0d0d0d] shadow-[0_0_12px_#00ff9022]";

const STATUS_STYLE = {
  open:        "text-[#00ff90] bg-[#00ff90]/10 border-[#00ff90]/20",
  "in progress":"text-blue-400 bg-blue-500/10 border-blue-500/20",
  pending:     "text-yellow-400 bg-yellow-500/10 border-yellow-500/20",
  waiting:     "text-yellow-400 bg-yellow-500/10 border-yellow-500/20",
  resolved:    "text-white/40 bg-white/5 border-white/10",
  closed:      "text-white/20 bg-white/5 border-white/5",
};

const PRIORITY_STYLE = {
  p1: "text-red-400",
  p2: "text-orange-400",
  p3: "text-yellow-400",
  p4: "text-white/40",
};

export default function TicketList({ onSelect, activeId, refreshKey = 0 }) {
  const [tickets, setTickets] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error,   setError]   = useState(null);

  useEffect(() => {
    const token = localStorage.getItem("token");
    if (!token) { setLoading(false); return; }
    fetch(`${API_BASE}/api/tickets/list`, {
      headers: { Authorization: `Bearer ${token}` },
    })
      .then(r => { if (!r.ok) throw new Error(`HTTP ${r.status}`); return r.json(); })
      .then(d => setTickets(Array.isArray(d) ? d : []))
      .catch(e => setError(e.message))
      .finally(() => setLoading(false));
  }, [refreshKey]);

  return (
    <div className={card}>
      <div className="px-5 py-4 border-b border-white/5 flex items-center justify-between">
        <span className="text-xs text-[#00ff90]/60 uppercase tracking-widest font-medium">My Tickets</span>
        {!loading && <span className="text-xs text-white/30">{tickets.length} total</span>}
      </div>

      <div className="p-4 space-y-2 max-h-96 overflow-y-auto">
        {loading && (
          <div className="space-y-2">
            {[1,2,3].map(i => <div key={i} className="h-14 rounded-lg bg-white/5 animate-pulse" />)}
          </div>
        )}
        {error && <p className="text-red-400 text-sm">⚠ {error}</p>}
        {!loading && !error && tickets.length === 0 && (
          <p className="text-white/20 text-sm italic text-center py-6">No tickets yet.</p>
        )}
        {!loading && !error && tickets.map(t => {
          const statusKey = (t.status || "").toLowerCase();
          const priorityKey = (t.priority || "").toLowerCase().split(" ")[0];
          const statusStyle = STATUS_STYLE[statusKey] || "text-white/40 bg-white/5 border-white/10";
          const priorityColor = PRIORITY_STYLE[priorityKey] || "text-white/30";
          const isActive = activeId === t.id;
          return (
            <button key={t.id} onClick={() => onSelect?.(t.id)}
              className={`w-full text-left rounded-lg border px-4 py-3 transition-all ${
                isActive
                  ? "border-[#00ff90]/40 bg-[#00ff90]/8"
                  : "border-white/5 bg-white/3 hover:border-[#00ff90]/20 hover:bg-[#00ff90]/5"
              }`}>
              <div className="flex items-start justify-between gap-2">
                <div className="min-w-0">
                  <p className="text-sm text-white font-medium truncate">{t.subject || t.title}</p>
                  <div className="flex items-center gap-2 mt-1 flex-wrap">
                    <span className="text-xs text-white/25">#{t.id}</span>
                    <span className={`text-xs font-medium ${priorityColor}`}>{t.priority}</span>
                    {t.category && <span className="text-xs text-white/25">{t.category}</span>}
                  </div>
                </div>
                <span className={`text-xs px-2 py-0.5 rounded-full border shrink-0 ${statusStyle}`}>
                  {t.status}
                </span>
              </div>
              <p className="text-xs text-white/20 mt-1">
                {(t.created_at || t.createdAt || t.created || "").replace("T", " ").slice(0, 16)}
              </p>
            </button>
          );
        })}
      </div>
    </div>
  );
}